/**
 * 与 docs/ue/事件描述信息.md 中 C# LangClass.GetResourceByKey 对应的中文文案（简体）。
 * 若与官方资源表有个别字差异，可在此统一调整。
 */
export const ED = {
  ZHEN: '帧',
  YINLIANG: '音量',
  NONE: '（无）',
  PEIYINWENBEN: '配音文本',
  GAOJIWENBEN: '高级文本',
  WENBEN: '文本',
  WENZIXUANXIANG: '文字选项',
  WENZIXUANXIANGEND: '文字选项结束',
  XIANSHIGUANGGAO: '显示广告',
  YIKANWANDEJUQING: '已看完的剧情',
  WEIKANWANDEJUQING: '未看完的剧情',
  XIANSHIGUANGGAOJIESHU: '显示广告结束',
  AUTOBOFANGJVQING: '自动播放剧情',
  KUAIJINJVQING: '快进剧情',
  SHUZHISHURU: '数值输入',
  TISHIXIAOXIKUANG: '提示消息框',
  GUAN: '关',
  KAI: '开',
  QINGCHU: '清除',
  BAOLIU: '保留',
  QIPAOMOSHI: '气泡模式',
  QISHIWEIZHIX: '起始位置X',
  QISHIWEIZHIY: '起始位置Y',
  XIANSHIQUYUKUAN: '显示区域宽',
  XIANSHIQUYUGAO: '显示区域高',
  FASHEQIPAO: '发射气泡',
  ZUO: '左',
  ZHONG: '中',
  YOU: '右',
  ZI: '字',
  /** 与 C# HARD_WENZI（动图替换「跟随文字」为「[文字]」）一致 */
  WENZI: '文字',
  TU: '图',
  YIN: '音',
  ZHUSHI: '注释',
  JIESHUXIANG: '结束项',
  DAOJISHIJVQING: '倒计时剧情',
  XIAOSHIDUIHUAKUANG: '消失对话框',
  DAKAIWANGYE: '打开网页',
  CAIDANGONGNENG: '菜单功能',
  SHUAXINUIJIEMIAN: '刷新UI界面',
  FANHUIYOUXI: '关闭界面',
  XUANFUZUJIANKAIGUAN: '悬浮组件开关',
  TIAOJIANFENQI: '条件分歧',
  CHANGSHIGOUMAI: '尝试购买',
  CHENGGONG: '成功',
  HUIFUGOUMAI: '恢复购买',
  FENQIEND: '分歧结束',
  XUNHUAN: '循环',
  YISHANGFANFU: '以上反复',
  TUPIANXUANXIANG: '图片选项',
  TUPIANXUANXIANGEND: '图片选项结束',
  TIAOZHUANJVQING: '跳转剧情',
  SHUZHICAOZUO: '数值操作',
  FANHUIBIAOTIHUAMIAN: '返回标题画面',
  ZHONGDUANXUNHUAN: '中断循环',
  CENGSHU: '层数',
  DENGDAI: '等待',
  CHUCIZHIWAIDEJVQING: '除此之外的剧情',
  ERZHOUMUSHUZHI: '二周目数值',
  XITONGBAOLIU: '系统保留',
  YOUXICAIDAN: '作品菜单',
  JVQINGHUIFANG: '剧情回放',
  JIANSHANG: '鉴赏',
  CUNDANGJIEMIAN: '存档界面',
  DUDANGJIEMIAN: '读档界面',
  YOUXISHEZHI: '作品设置',
  LIKAIYOUXI: '离开作品',
  ZIDONGJVQING: '自动剧情',
  YOUXISHANGCHENG: '作品商城',
  SHOUJIXITONG: '手机系统',
  XIANDINGSHANGCHENG: '限定商城',
  FULI: '福利',
  NAME_UI: '起名界面',
  DRESS_UI: '换装界面',
  HUJIAOYOUXIJIEMIAN: '呼叫作品界面',
  ZIFUCHUAN: '字符串',
  GAOJIERZHOUMU: '高级二周目',
  GAOJISHUZHI: '高级数值',
  QIANGZHIDUDANG: '强制读档',
  QIANGZHICUNDANG: '强制存档',
  HAO: '号',
  DUHOUSHANCHU: '读后删除',
  WUXIAO: '无效',
  QIPAOSHIXIAOGUO: '气泡式效果',
  HUJIAOZIJVQING: '呼叫子剧情',
  TIANQI: '天气',
  ZHENDONG: '震动',
  QIANGDU: '强度',
  SUDU: '速度',
  SHIJIAN: '时间',
  HUAMIANSHANSHUO: '画面闪烁',
  ZHUNBEIZHUANCHANG: '准备转场',
  KAISHIZHUANCHANG: '开始转场',
  GENGGAICHANGJINGSEDIAO: '更改场景色调',
  CHARUBGMJIANSHANG: '插入BGM鉴赏',
  CHARUCGJIANSHANG: '插入CG鉴赏',
  JIESUOSHOUJIXIANG: '解锁收集项',
  JIANYITEXIAO: '简易特效',
  YUANJINGTU: '远景图',
  BEIJINGTU: '背景图',
  QIANJINGTU: '前景图',
  LIHUI: '立绘',
  TOUMING: '透明度',
  HUANZHUANGJUESE: '换装角色',
  BIANHAO: '编号',
  TUPIANXIAOCHU: '图片消失',
  YIDONGTUPIAN: '移动图片',
  XIANSHIXINQING: '显示心情',
  XUANZHUANTUPIAN: '旋转图片',
  TPIANZHEZHAO: '图片遮罩',
  DANGQINATILIZHI: '当前体力值',
  JIAZAIZIYUAN: '加载资源',
  XIANSHIDONGTAITUPIAN: '显示动态图片',
  DONGZUO: '动作',
  XUNHUANBOFANG: '循环播放',
  GENSUIWENZI: '跟随文字',
  BOFANGBEIJINGYINYUE: '播放背景音乐',
  BOFANGYINXIAO: '播放音效',
  BOFANGYUYIN: '播放语音',
  BOFANGXUNHUANYINXIAO: '播放循环音效',
  DANCHUBEIJINGYINYUE: '淡出背景音乐',
  TINGZHIYINXIAO: '停止音效',
  TINGZHIYUYIN: '停止语音',
  DANCHUBEIJINGYINXIAO: '淡出循环音效',
  MIAO: '秒',
  JUMP_UI: '高级UI跳转事件',
} as const
